import { gql } from 'graphql-request'
import { ProfileTypes } from 'types/enums'
import { formalizationAPI } from '../api'

const ASSIGN_CUSTOMER_MUTATION = gql`
  mutation AssignCustomer($input: AssignCustomerInput!) {
    assignCustomer(input: $input) {
      applicationID
    }
  }
`

type DTO = {
  assignCustomer: Pick<Triage, 'applicationID'>
}

export async function assignCustomer(
  profileType: ProfileTypes,
): Promise<DTO['assignCustomer']> {
  const response = await formalizationAPI.request<DTO>(
    ASSIGN_CUSTOMER_MUTATION,
    { input: { profileType } },
  )
  return response.assignCustomer
}
